import { Link } from 'react-router-dom';
import { ArrowUpRight, Mail, Phone, MapPin, Linkedin, Twitter, Instagram, Dribbble } from 'lucide-react';

const currentYear = new Date().getFullYear();

const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#141414] border-t border-white/10">
      {/* CTA Section */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 border-b border-white/10">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold font-['Syne'] tracking-tight mb-4">
              Let's build something<br />
              <span className="text-[#af0000]">extraordinary</span>
            </h2>
            <p className="text-[#94a3b8] text-lg max-w-lg">
              Ready to transform your brand with cutting-edge design and technology? Let's talk.
            </p>
          </div>
          <Link
            to="/contact"
            data-testid="footer-cta-btn"
            className="group flex items-center gap-3 bg-[#af0000] hover:bg-[#8a0000] text-white px-8 py-4 rounded-full font-semibold transition-all hover:scale-105">

            Start a Project
            <ArrowUpRight size={20} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
          </Link>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <img
                src="/SQRX White Logo.png"
                alt="Squarex Studios"
                className="h-10 w-auto object-contain"
              />
            </Link>
            <p className="text-[#94a3b8] text-sm leading-relaxed mb-6">
              A creative agency specializing in Shopify development, design systems, and AI-powered visual production.
            </p>

          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold font-['Syne'] text-sm uppercase tracking-wider text-[#94a3b8] mb-6">
              Services
            </h4>
            <ul className="space-y-4">
              <li><Link to="/services" className="text-[#f8fafc] hover:text-[#af0000] transition-colors text-sm">Shopify Development</Link></li>
              <li><Link to="/services" className="text-[#f8fafc] hover:text-[#af0000] transition-colors text-sm">UI/UX Design</Link></li>
              <li><Link to="/apple-dev" className="text-[#f8fafc] hover:text-[#af0000] transition-colors text-sm">iOS & macOS Development</Link></li>
              <li><Link to="/services" className="text-[#f8fafc] hover:text-[#af0000] transition-colors text-sm">Branding</Link></li>
              <li><Link to="/services" className="text-[#f8fafc] hover:text-[#af0000] transition-colors text-sm">Video Production</Link></li>
              <li><Link to="/shotlab" className="text-[#f8fafc] hover:text-[#af0000] transition-colors text-sm">SQRX ShotLab</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold font-['Syne'] text-sm uppercase tracking-wider text-[#94a3b8] mb-6">
              Company
            </h4>
            <ul className="space-y-4">
              <li><Link to="/about" className="text-[#f8fafc] hover:text-[#af0000] transition-colors text-sm">About Us</Link></li>
              <li><Link to="/contact" className="text-[#f8fafc] hover:text-[#af0000] transition-colors text-sm">Contact</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold font-['Syne'] text-sm uppercase tracking-wider text-[#94a3b8] mb-6">
              Get in Touch
            </h4>
            <ul className="space-y-4">
              <li>
                <a href="mailto:hello@squarexstudios.com" className="flex items-center hover:text-[#af0000] transition-colors !text-sm gap-3 text-[#f8fafc]">
                  <Mail size={16} className="text-[#af0000]" />
                  hello@sqrx.in
                </a>
              </li>
              <li>
                <a href="tel:+919971140930" className="flex items-center gap-3 text-[#f8fafc] hover:text-[#af0000] transition-colors text-sm">
                  <Phone size={16} className="text-[#af0000]" />
                  +91 9971140930
                </a>
              </li>
              <li>
                <span className="flex items-start gap-3 text-[#94a3b8] text-sm">
                  <MapPin size={16} className="text-[#af0000] mt-0.5" />
                  Noida, Uttar Pradesh<br />
                  Lajpat Nagar, New Delhi
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[#64748b] text-sm">
            © {currentYear} Squarex Studios. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="/privacy-policy" className="text-[#64748b] hover:text-white text-sm transition-colors">Privacy Policy</a>
            <a href="#" className="text-[#64748b] hover:text-white text-sm transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>);

};

function SocialLinks() {
  return (
    <div className="flex gap-4">
      <a href="#" data-testid="social-linkedin" className="w-10 h-10 border border-white/10 flex items-center justify-center hover:border-[#af0000] hover:bg-[#af0000]/10 transition-all" aria-label="LinkedIn">
        <Linkedin size={18} className="text-[#94a3b8]" />
      </a>
      <a href="#" data-testid="social-twitter" className="w-10 h-10 border border-white/10 flex items-center justify-center hover:border-[#af0000] hover:bg-[#af0000]/10 transition-all" aria-label="Twitter">
        <Twitter size={18} className="text-[#94a3b8]" />
      </a>
      <a href="#" data-testid="social-instagram" className="w-10 h-10 border border-white/10 flex items-center justify-center hover:border-[#af0000] hover:bg-[#af0000]/10 transition-all" aria-label="Instagram">
        <Instagram size={18} className="text-[#94a3b8]" />
      </a>
      <a href="#" data-testid="social-dribbble" className="w-10 h-10 border border-white/10 flex items-center justify-center hover:border-[#af0000] hover:bg-[#af0000]/10 transition-all" aria-label="Dribbble">
        <Dribbble size={18} className="text-[#94a3b8]" />
      </a>
    </div>);

}

export default Footer;